export interface DNTCaptchaApiResponse {
  dntCaptchaImgUrl: string;
  dntCaptchaId: string;
  dntCaptchaTextValue: string;
  dntCaptchaTokenValue: string;
}

export interface DNTCaptchaState {
  apiResponse?: DNTCaptchaApiResponse;
  DNTCaptchaInputText: string;
  isLoading: boolean;
}

export interface DNTCaptchaParams {
  DNTCaptchaText: string;
  DNTCaptchaToken: string;
  DNTCaptchaInputText: string;
}

export interface DNTCaptchaRef {
  getResponse: () => DNTCaptchaParams;
  refresh: () => void;
}

export interface DNTCaptchaProps {
  placeholder?: string;
  dntCaptchaRef: (reference: DNTCaptchaRef) => void;
  realm: DNTCaptchaRealm;
  onLoadStateChange?: (isReady: boolean) => void;
}

export enum DNTCaptchaRealm {
  Security,
  Application
}
